export default "__VITE_ASSET__CN4Luv5K__"